/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1PersonMutationRequest,
  PostApiV1PersonMutationResponse,
  PostApiV1Person400,
  PostApiV1Person401,
  PostApiV1Person409,
  PostApiV1Person500,
} from "../../types/personRegisterController/PostApiV1Person.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1Person } from "../../clients/personRegisterController/postApiV1Person.ts";

export const postApiV1PersonMutationKey = () =>
  [{ url: "/api/v1/person" }] as const;

export type PostApiV1PersonMutationKey = ReturnType<
  typeof postApiV1PersonMutationKey
>;

export function postApiV1PersonMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1PersonMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1PersonMutationKey();
  return mutationOptions<
    PostApiV1PersonMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Person400
      | PostApiV1Person401
      | PostApiV1Person409
      | PostApiV1Person500
    >,
    { data?: PostApiV1PersonMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1Person(data, config);
    },
  });
}

/**
 * @description Cria uma nova pessoa com os dados informados. **(Requer Authorization para autenticação)**
 * @summary Criar pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person}
 */
export function usePostApiV1Person<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1PersonMutationResponse,
      ResponseErrorConfig<
        | PostApiV1Person400
        | PostApiV1Person401
        | PostApiV1Person409
        | PostApiV1Person500
      >,
      { data?: PostApiV1PersonMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<PostApiV1PersonMutationRequest>> & {
      client?: Client;
    };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1PersonMutationKey();

  const baseOptions = postApiV1PersonMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1PersonMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Person400
      | PostApiV1Person401
      | PostApiV1Person409
      | PostApiV1Person500
    >,
    { data?: PostApiV1PersonMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1PersonMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Person400
      | PostApiV1Person401
      | PostApiV1Person409
      | PostApiV1Person500
    >,
    { data?: PostApiV1PersonMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1PersonMutationResponse,
    ResponseErrorConfig<
      | PostApiV1Person400
      | PostApiV1Person401
      | PostApiV1Person409
      | PostApiV1Person500
    >,
    { data?: PostApiV1PersonMutationRequest },
    TContext
  >;
}
